import React, { useState, useContext } from 'react';
import './AuthPage.css';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from "../../context/AuthContext"; // ⭐ ADD THIS

function AuthPage() {

  const { fetchUser } = useContext(AuthContext); // ⭐ ADD THIS

  const [isLogin, setIsLogin] = useState(true);
  const navigate = useNavigate();
  const handleClose = () => navigate('/');

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
  });

  const [error, setError] = useState('');

  const API = process.env.REACT_APP_API_URL || "http://localhost:5000";

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleAuth = async (e) => {
    e.preventDefault();
    setError("");

    try {

      if (isLogin) {

        const { data } = await axios.post(
          `${API}/api/auth/login`,
          {
            email: formData.email,
            password: formData.password,
          }
        );

        localStorage.setItem("token", data.token);
        localStorage.setItem("role", data.user.role);
        localStorage.setItem("name", data.user.name);

        await fetchUser(); // ⭐ THIS IS THE MAGIC FIX

        navigate("/");

      } else {

        const { data } = await axios.post(
          `${API}/api/auth/request-registration`,
          {
            name: formData.name,
            email: formData.email,
            password: formData.password,
          }
        );

        alert(data.message);
        setIsLogin(true);
      }

    } catch (err) {
      setError(err.response?.data?.message || "Something went wrong");
    }
  };

  return (
    <div className="auth-container">
      <span className="close-button-auth" onClick={handleClose}>&larr;</span>

      <div className="auth-box fade-in">
        <h2>{isLogin ? 'Login' : 'Sign Up'}</h2>

        {error && <p className="auth-error">{error}</p>}

        <form onSubmit={handleAuth}>

          {!isLogin && (
            <input
              type="text"
              name="name"
              placeholder="Full Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          )}

          <input
            type="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            required
          />

          <input
            type="password"
            name="password"
            placeholder="Password"
            value={formData.password}
            onChange={handleChange}
            required
          />

          <button type="submit">
            {isLogin ? 'Login' : 'Sign Up'}
          </button>

        </form>

        <p>
          {isLogin ? "Don't have an account?" : 'Already have an account?'}
          <span
            className="auth-toggle"
            onClick={() => setIsLogin(!isLogin)}
          >
            {isLogin ? ' Sign Up' : ' Login'}
          </span>
        </p>

      </div>
    </div>
  );
}

export default AuthPage;
